/* eslint-disable react/forbid-prop-types */
import PropTypes from 'prop-types';
import React from 'react';
import { renderReactionBar } from '../../../pages/Community/utils';
import CreatorComponent from '../../Content/CreatorComponent/CreatorComponent';
import EditorialContentSection from '../../EditorialContent/EditorialContentSection/EditorialContentSection';
import PaidCompanySponsorLogo from '../../EditorialContent/PaidCompanySponsorLogo/PaidCompanySponsorLogo';
import FGBLabel from '../../Elements/FGBLabel/FGBLabel';
import ResponsivePicture from '../../Elements/ResponsivePicture/ResponsivePicture';
import PregnancyHeader from '../../Resources/PregnancyHeader/PregnancyHeader';
import AudioPlayer from '../AudioPlayer/AudioPlayer';
import ModerationMenu from '../ModerationMenu/ModerationMenu';
import SocialShareBar from '../../CallToAction/SocialShareBar/SocialShareBar';

import './EditorialPodcastSectionForSingleContent.scss';
import { PageContext } from '../../../contexts/ContextCreator';

const imageBps = {
    smallTablet: {
        width: 540,
        transforms: {
            quality: 'auto:best',
        },
    },
    mobile: {
        width: 340,
        transforms: {
            quality: 'auto:best',
        },
    },
};

const imageMaxHeights = {
    desktop: 750,
    tablet: 750,
    smallTablet: 750,
    mobile: 510,
};

export default class EditorialPodcastSectionForSingleContent extends React.PureComponent {
    renderPregnancyNav = () => {
        const { content: { category, additionalProps } = {} } = this.props;

        if (category !== 'pregnancy') {
            return null;
        }

        return <PregnancyHeader menuItems={additionalProps} />;
    };

    renderReactionBar = (content, showReactionBar) => {
        if (!showReactionBar) {
            return;
        }

        return renderReactionBar(
            content.hash,
            'singleContent',
            'left-aligned-bar'
        );
    };

    renderArticle = (content, currentTopic, showReactionBar) => {
        const articleProps =
            content.type === 'editorial-content'
                ? content.article
                : content.podcast; // hacky af

        // hide moderation menu for regular users seeing articles/ podcasts
        const userEditorialView =
            !this.context?.isAdmin &&
            (content.type === 'editorial-content' ||
                content.type === 'community-podcast');

        return (
            <React.Fragment>
                <div className="article-heading">
                    <FGBLabel>{articleProps?.wink}</FGBLabel>
                    {content.isPaid && (
                        <PaidCompanySponsorLogo
                            companyName={content.paidCompany.companyName}
                            companyImg={content.paidCompany.logo}
                            companyUrl={content.paidCompany.companyUrl}
                        />
                    )}
                    <div className="editorial-title">
                        {articleProps?.contentTitle}
                    </div>
                </div>
                <ResponsivePicture
                    cloudinaryID={articleProps?.contentImage?.src}
                    breakpoints={imageBps}
                    maxHeights={imageMaxHeights}
                />
                {articleProps?.contentImage?.credit ? (
                    <div className="photo-credit">
                        {articleProps.contentImage.credit}
                    </div>
                ) : null}
                {this.renderAudioPlayer(content)}
                <div className="article-body">
                    <div className="article-creatorContainer">
                        <CreatorComponent
                            author={content.author}
                            topic={currentTopic}
                            contentHash={content.hash}
                        />
                        {!userEditorialView && (
                            <ModerationMenu hash={content.hash} />
                        )}
                    </div>
                    <div className="article-shareContainer">
                        <SocialShareBar
                            hash={content.hash}
                            type={content.type}
                            location="singleContent"
                        />
                    </div>
                    <EditorialContentSection
                        content={articleProps?.contentBody}
                        topic={content.topic}
                        isPaid={content.isPaid}
                    />
                    {this.renderReactionBar(content, showReactionBar)}
                </div>
            </React.Fragment>
        );
    };

    renderAudioPlayer = (content) => {
        if (content.type === 'community-podcast' && content.podcast?.audioSrc) {
            return <AudioPlayer audioSrc={content.podcast.audioSrc} />;
        }
    };

    render() {
        const { content, currentTopic, showReactionBar } = this.props;

        return (
            <div className="component-Community-EditorialPodcastSectionForSingleContent renderedContentSection">
                {this.renderPregnancyNav()}
                {this.renderArticle(content, currentTopic, showReactionBar)}
            </div>
        );
    }
}

EditorialPodcastSectionForSingleContent.contextType = PageContext;

EditorialPodcastSectionForSingleContent.propTypes = {
    content: PropTypes.object.isRequired,
    currentTopic: PropTypes.object.isRequired,
    showReactionBar: PropTypes.bool,
};

EditorialPodcastSectionForSingleContent.defaultProps = {
    showReactionBar: true,
};
